import type { ToolEvent } from "../types";

interface Props {
  event: ToolEvent;
}

export function ToolEventRow({ event }: Props) {
  const inputPreview = preview(event.input);
  return (
    <div className={`tool-event ${event.isError ? "is-error" : ""}`}>
      <span className="tool-arrow">→</span>{" "}
      <span className="tool-name">{event.name}</span>
      <span className="tool-input">{inputPreview}</span>
    </div>
  );
}

function preview(input: unknown): string {
  if (input == null) return "";
  if (typeof input === "string") return input.length > 100 ? `${input.slice(0, 100)}…` : input;
  try {
    const s = JSON.stringify(input);
    return s.length > 120 ? `${s.slice(0, 120)}…` : s;
  } catch {
    return String(input);
  }
}
